app.directive('sgSelect2', function($parse) {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
            var config = {};

            $scope.linkedProgramTemplate = function (searchResult) {
                    var image = searchResult.element ?
                    '<img src="'+searchResult.element.getAttribute('data-image')+'" class="select2-results__option-img">' :
                    '';
                return $('<span><span class="select2-results__option-imgframe">'+image+'</span> '+searchResult.text+'</span>');
            };

            $scope.similarExerciseTemplate = function (searchResult) {
                var image = searchResult.element ?
                    '<img src="'+searchResult.element.getAttribute('data-image')+'" class="select2-results__option-img">' :
                    '';
                return $('<span><span class="select2-results__option-imgframe">'+image+'</span> '+searchResult.text+'</span>');
            };

            if ($attrs.sgSelect2) {
                config = $parse($attrs.sgSelect2)($scope);
            }

            if ($attrs.tags) {
                config.tags = true;
            }

            var currentLocale = angular.element('html').attr('lang');
            config.language = currentLocale;

            $element.select2(config);
        }
    };
});
